<template>
  <div>
    <h1 class="text-center">Kontakt</h1>

    <div class="text-center mt-4">
      <p>Hvis du har nogen spørgsmål er du velkommen til at kontakte mig enten pr. telefon eller brug formularen.</p>

      <br />
      <br />

      <p>
        Kennel Hillsbrook
        <br />v/ Claus Rydahl
        <br />Sandagervej 17
        <br />4690 Haslev
        <br />
        <br />Mobil: 60 77 02 00
      </p>

      <v-form class="contactForm mx-auto" ref="form" v-model="valid" lazy-validation>
        <v-text-field v-model="name" :counter="10" :rules="nameRules" label="Navn" required></v-text-field>

        <v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>

        <v-textarea v-model="message" no-resize :rules="messageRules" label="Besked" required></v-textarea>

        <v-btn :disabled="!valid" color="primary" class="mr-4 float-right" @click="submit">Send</v-btn>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Kontakt',
  data: () => ({
    valid: true,
    name: '',
    nameRules: [(v) => !!v || 'Udfyld navn'],
    email: '',
    emailRules: [
      (v) => !!v || 'Udfyld e-mail',
      (v) => /.+@.+\..+/.test(v) || 'Udfyld en gyldig e-mail'
    ],
    message: '',
    messageRules: [(v) => !!v || 'E-mail is required']
  }),
  computed: {
    ...mapState(['test', 'dogs'])
  },
  methods: {
    submit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        // Todo: Send email
        console.log('hep');
      }
    }
  }
};
</script>

<style lang="less">
.contactForm {
  width: 400px;
  margin-top: 30px;
}
</style>